import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

let swiperInstance;

function initSwiper() {
  if (swiperInstance) {
    swiperInstance.destroy(true, false);
  }

  swiperInstance = new Swiper(".slider", {
    modules: [Navigation],
    slidesPerView: "auto", // ✅ Show multiple slides at once, but auto width!
    centeredSlides: true, // ✅ Center active slide, show prev/next peeking
    spaceBetween: 0,
    freeMode: true,
    loop: true,
    navigation: {
      nextEl: ".slider-button-next",
      prevEl: ".slider-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false, // ✅ Reset to normal at tablet+
        spaceBetween: 36,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 48,
      },
      1528: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 48,
      },
    },
  });
}

initSwiper();

window.initSwiper = initSwiper;
